// Registry + public entry points for the third-party snippet system.
//
// To add a new third-party snippet in the future:
//   1. Create `src/utilities/third-party/<name>.js` exporting a
//      `ThirdPartySnippet` subclass instance (see `intercom.js` /
//      `optimizely.js`).
//   2. Add it to the `SNIPPETS` array below.
// The core files (`gatsby-browser.js`, `gatsby-ssr.js`,
// `src/context/osano-context.js`) call only the stable wrappers at the bottom of
// this file, so they do not change when snippets are added.
import { SnippetManager } from './snippet-manager';
import intercomSnippet from './intercom';
import optimizelySnippet from './optimizely';

export const SNIPPETS = [
  intercomSnippet,
  optimizelySnippet
];

export const snippetManager = new SnippetManager(SNIPPETS);

// --- Stable API consumed by the app's core lifecycle hooks -----------------

// Called once on client entry (gatsby-browser `onClientEntry`). Sets up the
// first-interaction bridge and loads any immediate snippets.
export const startThirdPartySnippets = (location) => snippetManager.start(location);

// Called on every Gatsby route update (gatsby-browser `onRouteUpdate`).
export const handleThirdPartyRouteChange = (location) => (
  snippetManager.handleRouteChange(location)
);

// Called whenever Osano consent changes (OsanoProvider). Drives consent-gated
// snippets such as Optimizely.
export const handleThirdPartyConsent = (consent) => (
  snippetManager.handleConsentChange(consent)
);

export { SnippetManager } from './snippet-manager';
export {
  ThirdPartySnippet,
  TRIGGERS,
  isLiveHost,
  isForced,
  isLiveOrForced,
  injectScript
} from './snippet';

export default snippetManager;
